module.exports = __webpack_public_path__ + "media/images/icons/grid-three-up-58689f3671da1ad4b0c09415c852a456.svg";